export default "__VITE_ASSET__9a14e8bb__"